import { render, staticRenderFns } from "./government.vue?vue&type=template&id=7ad979dc&scoped=true&"
import script from "./government.vue?vue&type=script&lang=js&"
export * from "./government.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad979dc",
  null
  
)

export default component.exports